import clsx from 'clsx';
import { useState } from 'react';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import AddLink from '~components/generic/elements/add-link/AddLink';
import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { IEntityComponentProps } from '~interfaces/props';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';

export default function ModuleAccordion(props: IEntityComponentProps) {
  const [activeAccordionIndex, setActiveAccordionIndex] = useState<boolean | number>(false);

  const handleActivate = (i: number) => {
    setActiveAccordionIndex(curr => (curr === i ? false : i));
  };

  const { data, editing, className, onChange, onAddNewChild, origData, stable } = props;
  if (!data) {
    return null;
  }
  const content = data.attributes;
  const childModuleIds = getRelatedEntityIds(data, 'field_items');
  const moduleClasses = clsx({
    ...className.module,
  });
  const containerClasses = {
    ...className.container,
    'px-0': true,
    relative: true,
  };

  return (
    <div className={clsx(moduleClasses)} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className={clsx(containerClasses)}>
        <div className="c-module__header">
          <EditableField
            hide={content.field_hide_title}
            entityType={data.type}
            fieldName="attributes.field_title.value"
            data={content.field_title.value}
            editing={editing}
            onChange={onChange}
          />
        </div>
        <ul className="c-accordion u-margin-vertical-md js-accordion c-module__content">
          {childModuleIds.map((id, i) => {
            const isActive = i === activeAccordionIndex;
            return (
              <DraggableModuleContainer
                parentIsStable={stable}
                index={i}
                isActive={isActive}
                onActivate={() => handleActivate(i)}
                key={id}
                entityId={id}
                parentContext={data.id}
                parentType={data.type}
                fieldName="relationships.field_items.data"
                canMove={editing}
              />
            );
          })}
        </ul>
        {editing && (
          <AddLink
            onClick={() =>
              onAddNewChild({
                id: origData,
                fieldName: 'relationships.field_items.data',
                templateType: 'paragraph--accordion_item',
              })
            }
          />
        )}
      </div>
    </div>
  );
}
